module.exports = __webpack_public_path__ + "static/media/jackpot-inner-background.9db6b3d9.png";